import React, { createContext, useState, useEffect } from 'react';

export const TitleContext = createContext();

export const TitleProvider = ({ children }) => {
    const [title, setTitle] = useState('');

    useEffect(() => {
        if (title) {
            document.title = `${title} | Trendify Ads Admin`;
        } else {
            document.title = 'Trendify Ads Admin';
        }
    }, [title]);

    return (
        <TitleContext.Provider value={{ title, setTitle }}>
            {children}
        </TitleContext.Provider>
    );
};
